require('./bootstrap');

require('./quid_app.js');